import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-route-vehicle-edit',
  templateUrl: './route-vehicle-edit.component.html',
  styleUrls: ['./route-vehicle-edit.component.scss']
})
export class RouteVehicleEditComponent implements OnInit {
  vehicles: Object;
  vehicle_id = null
  route_id: any;
  constructor(public dialogRef: MatDialogRef<RouteVehicleEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private http: HttpService) {
    console.log(data);
    this.vehicle_id = data['vehicle_id']
    this.route_id = data['route_id']
    this.http.getVehicle().subscribe((data) => {
      console.log(data);
      this.vehicles = data
    });
  }

  ngOnInit() {
  }

  changeVehicle() {
    console.log(this.vehicle_id)
    const data_dict = {
      'vehicle_id': this.vehicle_id,
      'route_id': this.route_id
    }
    this.http.changeVehicle(data_dict).subscribe((data) => {
      console.log(data);
      if (data['status'] == 'success') {
        this.dialogRef.close(true)
      }
      if (data['status'] == 'confirm') {
        if (confirm(data['message'])) {
          this.http.changeVehicleForRoute(data_dict).subscribe((data) => {
            console.log('changed success')
            this.dialogRef.close(true)
          })
        }
      }
    })
  }

}
interface DialogData {
  id: number;
}
